import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    createTodoItem: 'Create todo item',
    createTodoItemReasoning: 'Creating todo item',
    createTodoItemOutput: 'Created todo item',
    createTodoItemError: 'Error creating todo item',
    createTodoList: 'Create todo list',
    createTodoListReasoning: 'Creating todo list',
    createTodoListOutput: 'Created todo list',
    createTodoListError: 'Error creating todo list',
    findTodoItems: 'Find todo items',
    findTodoItemsReasoning: 'Finding todo items',
    findTodoItemsOutput: 'Found todo items',
    findTodoItemsError: 'Error finding todo items',
    findTodoItemsNoop: 'No todo items found',
    findTodoLists: 'Find todo lists',
    findTodoListsReasoning: 'Finding todo lists',
    findTodoListsOutput: 'Found todo lists',
    findTodoListsError: 'Error finding todo lists',
    findTodoListsNoop: 'No todo lists found',
    readTodoItem: 'Read todo item',
    readTodoItemReasoning: 'Reading todo item',
    readTodoItemOutput: 'Read todo item',
    readTodoItemError: 'Error reading todo item',
    readTodoList: 'Read todo list',
    readTodoListReasoning: 'Reading todo list',
    readTodoListOutput: 'Read todo list',
    readTodoListError: 'Error reading todo list',
    searchTodoItems: 'Search todo items',
    searchTodoItemsReasoning: 'Searching todo items',
    searchTodoItemsOutput: 'Found todo items',
    searchTodoItemsError: 'Error searching todo items',
    searchTodoItemsNoop: 'No todo items found',
    searchTodoLists: 'Search todo lists',
    searchTodoListsReasoning: 'Searching todo lists',
    searchTodoListsOutput: 'Found todo lists',
    searchTodoListsError: 'Error searching todo lists',
    searchTodoListsNoop: 'No todo lists found',
    trashTodoItem: 'Send todo item to trash',
    trashTodoItemReasoning: 'Sending todo item to trash',
    trashTodoItemOutput: 'Sent todo item to trash',
    trashTodoItemError: 'Error sending todo item to trash',
    trashTodoList: 'Send todo list to trash',
    trashTodoListReasoning: 'Sending todo list to trash',
    trashTodoListOutput: 'Sent todo list to trash',
    trashTodoListError: 'Error sending todo list to trash',
    updateTodoItem: 'Update todo item',
    updateTodoItemReasoning: 'Updating todo item',
    updateTodoItemOutput: 'Updated todo item',
    updateTodoItemError: 'Error updating todo item',
    updateTodoList: 'Update todo list',
    updateTodoListReasoning: 'Updating todo list',
    updateTodoListOutput: 'Updated todo list',
    updateTodoListError: 'Error updating todo list',
  });
}
